import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { getVideoPlayer, VideoJsPlayer } from './getVideoPlayer'

export interface VideoState {
  contentId: string | null
  featureMediaId: string | null
}

export interface VideoPlayerPlaybackState {
  currentTimeSeconds: number | null
  isPaused: boolean | null
}

interface VideoJsPlayerWithPaused extends VideoJsPlayer {
  paused?: () => boolean
}

export interface UseVideoStateReturn extends VideoState {
  getPlaybackState: () => VideoPlayerPlaybackState
}

export function useVideoState (): UseVideoStateReturn {
  const video = useSelector((state: unknown) => {
    type HasGetIn = { video?: { getIn: (path: string[]) => unknown } }
    return (state as HasGetIn).video
  })

  const contentId = video?.getIn?.(['data', 'id'])
  const featureMediaId = video?.getIn?.(['data', 'feature', 'id'])

  const getPlaybackState = useCallback((): VideoPlayerPlaybackState => {
    const player = getVideoPlayer() as VideoJsPlayerWithPaused | null

    if (!player) {
      return {
        currentTimeSeconds: null,
        isPaused: null,
      }
    }

    try {
      const currentTimeSeconds = typeof player.currentTime === 'function'
        ? player.currentTime()
        : null
      const isPaused = typeof player.paused === 'function'
        ? player.paused()
        : null

      return {
        currentTimeSeconds,
        isPaused,
      }
    } catch {
      return {
        currentTimeSeconds: null,
        isPaused: null,
      }
    }
  }, [])

  return {
    contentId: contentId ? String(contentId) : null,
    featureMediaId: featureMediaId ? String(featureMediaId) : null,
    getPlaybackState,
  }
}
